module.exports = __webpack_public_path__ + "static/mayukh-1933cf9925bba6ac27a28c1053acd08c.jpg";